import { render } from "./cdrBatchAllocation.vue?vue&type=template&id=397c5f3e&scoped=true"
import script from "./cdrBatchAllocation.vue?vue&type=script&lang=js"
export * from "./cdrBatchAllocation.vue?vue&type=script&lang=js"

import "./cdrBatchAllocation.vue?vue&type=style&index=0&id=397c5f3e&scoped=true&lang=css"
import "./cdrBatchAllocation.vue?vue&type=style&index=1&id=397c5f3e&lang=css"
script.render = render
script.__scopeId = "data-v-397c5f3e"

export default script